import { type FC, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Spin } from 'antd';

import { services as oidcServices } from '@nvision/identity-core';

import { logOut } from '../utils/auth';

const checkIsUrlFromIdentity = (searchParams: URLSearchParams) => searchParams.get('from') === 'identity';

export const OIDCAuthReset: FC = () => {
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);
  const isFromIdentity = checkIsUrlFromIdentity(searchParams);

  useEffect(() => {
    if (isFromIdentity) {
      oidcServices.auth.disableOIDCProvider();
      logOut();
    }
  }, [isFromIdentity]);

  return <Spin size="default" style={{ height: 20 }} />;
};
